import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { proApi, getProToken } from "@/lib/proApi";
import { fmtDateTime, fmtDate } from "@/lib/api";

const payLabel = (s) => ({ paid: "Bezahlt", payment_requested: "Offen", pending: "Ausstehend", free: "Kostenlos", unpaid: "Offen", open: "Offen", comp: "Freiplatz", waitlist: "Warteliste", failed: "Zahlung fehlgeschlagen" }[s] || s || "—");

const ProPrint = () => {
  const { sessionId } = useParams();
  const [d, setD] = useState(null);

  useEffect(() => {
    proApi.get(`/pro/sessions/${sessionId}/participants`).then((r) => {
      setD(r.data);
      setTimeout(() => window.print(), 600);
    }).catch(() => {});
  }, [sessionId]);

  if (!getProToken()) return <Navigate to="/pro-login" replace />;
  if (!d) return <div style={{ padding: 40 }}>Lädt…</div>;

  const p = d.participants || [];
  const totalPersons = p.reduce((s, x) => s + (x.waitlist ? 0 : (x.persons || 1)), 0);
  return (
    <div className="print-root" data-testid="pro-print">
      <style>{`
        @page { size: A4; margin: 14mm; }
        @media print { .no-print { display: none !important; } body { background: #fff; } }
        .print-root { background:#fff; color:#000; font-family: Helvetica, Arial, sans-serif; padding: 24px; max-width: 800px; margin: 0 auto; }
        .print-root table { width:100%; border-collapse: collapse; }
        .print-root th, .print-root td { border:1px solid #ccc; padding:6px 8px; font-size:12px; text-align:left; }
        .print-root thead th { background:#0F0F0F; color:#fff; }
        .print-root tbody tr:nth-child(even){ background:#f2f2f2; }
        thead { display: table-header-group; }
      `}</style>
      <div className="no-print" style={{ marginBottom: 16 }}>
        <button onClick={() => window.print()} style={{ background: "#ff0033", color: "#fff", border: 0, padding: "10px 18px", cursor: "pointer", textTransform: "uppercase", fontWeight: 700 }}>Drucken</button>
      </div>
      <div style={{ fontSize: 10, letterSpacing: 2, color: "#ff0033", fontWeight: 700 }}>GOLFCOACHING ACADEMY WENDLINGEN</div>
      <h1 style={{ fontSize: 22, margin: "6px 0" }}>Teilnehmerliste</h1>
      <div style={{ fontSize: 12, color: "#444", lineHeight: 1.5 }}>
        <div><b>Kurs:</b> {d.course?.name}</div>
        <div><b>Datum/Zeit:</b> {fmtDateTime(d.session?.start)} &nbsp;•&nbsp; <b>Ort:</b> {d.course?.location || "GC Kirchheim-Wendlingen"}</div>
        <div><b>Trainer:</b> {d.session?.coach || "—"} &nbsp;•&nbsp; <b>Teilnehmer:</b> {totalPersons} ({p.length} Anmeldungen)</div>
        <div><b>Stand:</b> {new Date().toLocaleString("de-DE", { timeZone: "Europe/Berlin" })} Uhr</div>
      </div>
      <div style={{ borderTop: "2px solid #ff0033", margin: "10px 0 14px" }} />
      <table>
        <thead>
          <tr><th>#</th><th>Name</th><th>Pers.</th><th>Telefon</th><th>E-Mail</th><th>Adresse</th><th>Mitgl.</th><th>Zahlung</th><th>Bemerkung</th><th>Anw.</th></tr>
        </thead>
        <tbody>
          {p.map((x, i) => (
            <tr key={i}>
              <td>{i + 1}</td><td>{x.last_name}, {x.first_name}{x.waitlist ? " (Warteliste)" : ""}</td><td>{x.persons || 1}</td><td>{x.phone || "—"}</td>
              <td>{x.email || "—"}</td><td>{x.address || "—"}</td><td>{x.member ? "Ja" : "—"}</td><td>{payLabel(x.payment_status)}</td>
              <td>{x.note || ""}</td><td style={{ width: 30 }}>☐</td>
            </tr>
          ))}
          {p.length === 0 && <tr><td colSpan={10} style={{ textAlign: "center" }}>Noch keine Teilnehmer.</td></tr>}
        </tbody>
      </table>
      <div style={{ marginTop: 24, fontSize: 12 }}><b>Trainer-Notizen:</b></div>
      {[0, 1, 2, 3, 4].map((i) => <div key={i} style={{ borderBottom: "1px solid #ddd", height: 22 }} />)}
    </div>
  );
};

export default ProPrint;
